<template>
  <div class="deviceupgrade" v-loading="loadingPlas" :class="{ 'mask-active': maskBox }">
    <div class="upgradeInfo">
      <div class="closepage" @click="clickClosepage"></div>
      <div class="xinxi">
        <span class="top-info">
          <span class="label">
            <i class="status-icon-shadow" :class="deviceStatus.class"></i>
          </span>
          <span class="namebox">
            <span class="name">{{ deviceInfo.devalias || deviceInfo.sn }}</span>
          </span>
        </span>
        <div class="infobox">
          <div class="cell light gCell11 splitHLine">{{ $t('device.device_sn') }}</div>
          <div class="cell light gCell12 splitHLine">{{ $t('device.device_type') }}</div>
          <div class="cell light gCell13 splitHLine">{{ $t('datalogger.Firmware_Version') }}</div>
          <div class="cell1 light gCell14 splitHLine">{{ $t('device.device_code') }}</div>
          <div class="cell data dark gCell21 splitHLine">{{ deviceInfo.deviceSn||deviceInfo.sn }}</div>
          <div class="cell data dark gCell22 splitHLine">{{ deviceInfo.brand | translateDeviceType }}</div>
          <div class="cell data dark gCell23 splitHLine">{{ deviceInfo.device_Firmware_Version || '--' }}</div>
          <div class="cell1 data dark gCell24 splitHLine">{{ deviceInfo.devcode }}</div>
        </div>
      </div>
    </div>
    <div class="infobox1">
      <div class="bTitle1">{{ $t('device.device_upgrade1') }}</div>
      <div class="cell light bCell11 splitHLine">{{ $t('device.device_upgradeTime') }}</div>
      <!-- <div class="cell light bCell12 splitHLine">{{$t('device.device_upgradeName')}}</div> -->
      <div class="cell light bCell13 splitHLine">{{ $t('device.device_upgradeStatus') }}</div>
      <div class="cell1 light bCell14 splitHLine">{{ $t('device.device_upgradeProgress') }}</div>
      <div class="cell dark bCell21 splitHLine" style="min-width: 0;">
        {{ upgradedata.ts || $t('firmware.noRecord') ||
          "--" }}
      </div>
      <!-- <div class="cell  dark bCell22 splitHLine">{{ deviceInfo.alias || deviceInfo.pn }}</div> -->
      <div class="cell dark bCell23 splitHLine">
        <template slot-scope>
          <!-- <div v-if="upgradedata.ret == 5">{{ $t('firmware.upgrade_quit5') }}</div> -->
          <div v-if="upgradedata.ret == 4">{{ $t('firmware.upgrade_quit6') }}</div>
          <div v-else-if="upgradedata.ret == 3" style="color:#30EC70;">{{ $t('firmware.upgrade_quit3') }}</div>
          <div v-else-if="upgradedata.ret == 2" style="color:#FF3E3E;">{{ $t('firmware.upgrade_quit7') }}</div>
          <div v-else-if="upgradedata.ret == 1" style="color:#EC9630;">{{ $t('firmware.upgrading') }}</div>
          <div v-else-if="upgradedata.ret == 0">{{ $t('firmware.upgrading1') }}</div>
          <div v-else>{{ $t('errCode.12') }}</div>
        </template>
      </div>
      <div class="cell1 data dark bCell24 splitHLine">{{ upgradedata.progress || $t('errCode.12') }}</div>
      <div class="bTitle2">
        <div>
          {{ $t('device.device_upgradeFirmware') }}
        </div>
        <div>
          <button :disabled="upgradeButtonDisable" v-if="deviceInfo.otaLabel" class="todetail" @click="intelligenceUpgrade()">
            LFU
          </button>
          <button class="todetail" @click="addFirmware()">
            {{ $t('device.Upload1') }}
          </button>
        </div>
      </div>
    </div>
    <!-- <div v-if="!upgradeUPG.upgradeUPG">
        <el-table
          style="background:#222D35;color:#fff;"
          class="tablemain tableloding"
          v-loading="isLoading"
          element-loading-spinner="el-icon-loading"
          height="430px"
          :data="dataTable"
          :header-cell-style="{ background: '#222D35', color: '#ffffff' }"
          :empty-text="$t('account.nodata')"
          @selection-change="handleSelectionChange"
          ref="tableRef"
          :row-style="isRed"
          :header-cell-class-name="cellClass"
        >
          <el-table-column
            width="130px"
            type="index"
            :label="$t('recharge.serial_number')"
            header-align="center"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="firmware"
            :label="this.$t('firmware.Firmware_Name')"
            min-width="150px"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            :label="this.$t('firmware.Firmware_desrc')"
            min-width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span :title="scope.row.desc || '--'">{{ scope.row.desc || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="size"
            :label="this.$t('firmware.Size')"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="gts"
            :label="this.$t('firmware.Upload_Time')"
            min-width="150px"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="勾选" width="105" type="selection"></el-table-column>
        </el-table>
      </div>-->
    <!-- 透传升级 -->
    <div  class="table">
      <el-table style="background:#222D35;color:#fff;" class="tablemain tableloding" v-loading="isLoading"
        element-loading-spinner="el-icon-loading" height="100%" :data="dataTable"
        :header-cell-style="{ background: '#222D35', color: '#ffffff' }" :empty-text="$t('account.nodata')"
        @selection-change="handleSelectionChange" ref="tableRef" :row-style="isRed" :header-cell-class-name="cellClass">
        <el-table-column label="勾选" width="105" type="selection"></el-table-column>
        <el-table-column width="130px" type="index" :label="$t('recharge.serial_number')" header-align="center"
          align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firmwareName" :label="this.$t('firmware.Firmware_Name')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="this.$t('firmware.Firmware_desrc')" min-width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.note || '--'">{{ scope.row.note || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fileSize" :label="this.$t('firmware.Size')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createTime" :label="this.$t('firmware.Upload_Time')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="this.$t('firmware.Operation')" fixed="right" width="100px"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- <el-button
                type="text"
                class="operation"
                :title="$t('firmware.editFirmware')"
                @click="editFirmwareDialog(scope.row)"
              >
                <i class="iconfont icon-bianji"></i>
              </el-button> -->
            <el-button type="text" class="operation" :title="$t('firmware.deleteFirmware')"
              @click="deleteFirmware(scope.row)">
              <i class="iconfont icon-delete"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="upgardeButtom" :class="progressUp ? 'upgardeButtomUP':'upgardeButtomDo'">
      <div class="progressBox" v-if="progressUp">
        <div class="topbox" style="display:flex">
        <el-progress :format="progressText" :percentage="progress" style="width:200px" color="#33FFB6"></el-progress>
        <button style="margin-top: -10px;" v-show="progressUp" class="btn btn-dark" @click="upgradeCancel">{{
          $t('firmware.upgrade_quit6') }}</button>
        </div>
        <div class="firDesc" v-if="progressUp">
           <div class="item" v-if="firName">{{ $t('firmware.Firmware_Name') }}：<span :title="firName">{{ firName }}</span></div>
           <div class="item" v-if="firDesc">{{ $t('firmware.Firmware_desrc') }}：<span :title="firDesc">{{ firDesc }}</span></div>
        </div>
      </div>
      <div class="buttonBox"  :class="progressUp ? 'buttonBoxUP':'buttonBoxDo'">
        <button type="button" class="btn-dark1" @click="submitBox">
          <span>{{ $t('datalogger.confirm') }}</span>
          <!-- <span v-if="!buttonUpgrade">{{ $t('firmware.upgrading') }}</span> -->
        </button>
      </div>
    </div>
    <!-- <div class="maskBox" v-if="maskBox"></div> -->
    <firmware-dialog :visible.sync="dialogVisible"
      :class="{ 'showDialog': dialogVisible, 'hideDialog': !dialogVisible }" width="30vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <i class="iconfont icon-gantanhao"></i>
          <span class="contentdelete">{{ $t('firmware.delete_firmware') }}</span>
        </div>
        <div class="disabledescr">{{ $t('account.notRecovered') }}</div>
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter">
          <button type="primary" class="button-solid" @click="configdelete()">{{ $t('firmware.confirm') }}</button>
          <button class="button-hollow btn-light" @click="dialogVisible = false">{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </firmware-dialog>
    <firmware-dialog :visible.sync="dialogVisibleFelst"
      :class="{ 'showDialog': dialogVisibleFelst, 'hideDialog': !dialogVisibleFelst }" width="21vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <i class="iconfont icon-gantanhao"></i>
          <span>{{ dialogVisibleFelstText }}</span>
        </div>
        <!-- <div class="disabledescr">{{$t('account.notRecovered')}}</div> -->
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter">
          <button type="primary" class="button-solid" @click="dialogVisibleFelst = false">{{ $t('datalogger.confirm')
          }}</button>
          <!-- <button class="button-hollow" @click="dialogVisibleFelst = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
    </firmware-dialog>
    <firmware-dialog :title="$t('firmware.Upload_firmware')"
      :class="{ 'showDialog': dialogAdd, 'hideDialog': !dialogAdd }" :visible.sync="dialogAdd" width="40vw" noFooter>
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input type="file" class="upload-input" ref="fileUploader" accept="application/octet-stream"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="warningTipButton">{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </firmware-dialog>
    <firmware-dialog :title="$t('device.device_upgrade')" :visible.sync="upgradeDeviceVisible" :class="{
      showDialog: upgradeDeviceVisible,
      hideDialog: !upgradeDeviceVisible,
    }" width="580px" noFooter>
      <div slot="content">
        <el-form class="grid upload-container upgradeNew">
          <el-form-item :label="$t('device.select_firmware')" size="small">
            <el-input disabled v-model="firmware1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('device.firmware_type')" size="small">
            <!-- [定制]根据文件名自动选择固件类型disabled -->
            <el-select v-if="!hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
              popper-class="select-search-recharge" ref="autoSelected">
              <el-option v-for="item in firmwaretypelist" :key="item.id" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
            <el-select v-if="hideFlag" v-model="searchrecharge.firmwaretype" :placeholder="$t('device.select_type')"
              popper-class="select-search-recharge" ref="autoSelected">
              <el-option v-for="item in firmwaretypelist1" :key="item.id" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.upgrade_brate')" size="small">
            <el-select v-model="searchrecharge.brate" :placeholder="$t('device.select_brate')"
              popper-class="select-search-recharge">
              <el-option v-for="item in bratelist" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label=" ">
  
            </el-form-item>-->
        </el-form>
        <div style="text-align: right">
          <button style="margin-right: 20px;" v-show="progressUp" class="btn btn-dark" @click="upgradeCancel">{{
            $t('firmware.upgrade_quit6') }}</button>
          <button type="button" class="btn btn-dark" @click="submitUpgradeDatalogger">{{ $t("device.confirm")
          }}</button>
        </div>
      </div>
      <div slot="footer"></div>
    </firmware-dialog>

    <!-- 特殊处理，等待升级设备界面 -->
    <firmware-dialog :visible.sync="waitingUpgradeVisible"
      :class="{ 'showDialog': waitingUpgradeVisible, 'hideDialog': !waitingUpgradeVisible }" width="21vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <i class="iconfont icon-gantanhao"></i>
          <span>{{ waitingUpgradeText }}</span>
        </div>
        <div style="margin-top: 20px;" v-if="dataloggerPercentageFlag">
          <el-progress color="#33FFB6" :percentage=dataloggerPercentageValue></el-progress>
        </div>
      </div>
    </firmware-dialog>
    <!-- 编辑固件对话框 -->
    <firmware-dialog :visible.sync="editFirmwareVisible"
      :class="{ 'showDialog': editFirmwareVisible, 'hideDialog': !editFirmwareVisible }" width="420px" noContentClose
      :title="$t('upgradeManagement.edit_firmware')">
      <div slot="content">
        <el-form :model="editFirmwareForm" :rules="editFirmwareRules" ref="editFirmwareForm" label-width="100px"
          class="eb-form" label-position="top">
          <el-form-item prop="name" class="el-form-group-item">
            <!-- 固件名称  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{ $t('upgradeManagement.firmware_name') }}</span>
            </span>
            <!-- content -->
            <span class="eb-inputwrapper" style="margin-right:10px;width:100%">
              <el-input class="eb-input" :placeholder="$t('upgradeManagement.please_input')"
                v-model="editFirmwareForm.name" clearable :maxlength="32"></el-input>
            </span>
          </el-form-item>
          <el-form-item prop="versionNote" class="el-form-group-item">
            <!-- 版本号  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff;">{{ $t('upgradeManagement.Firmware_Version') }}</span>
            </span>
            <!-- content -->
            <span class="eb-inputwrapper" style="margin-right:10px;width:100%">
              <el-input class="eb-input" :placeholder="$t('upgradeManagement.please_input')"
                v-model="editFirmwareForm.versionNote" clearable :maxlength="16"></el-input>
            </span>
          </el-form-item>
          <el-form-item prop="note" class="el-form-group-item">
            <!-- 备注说明  -->
            <span slot="label">
              <!-- 标签及星号 -->
              <span style="color:#fff">{{ $t('upgradeManagement.Remarks') }}</span>
            </span>
            <!-- content -->
            <el-input type="textarea" :placeholder="$t('firmware.enter_content')" v-model="editFirmwareForm.note"
              :maxlength="64" show-word-limit>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <!-- 取消  -->
        <el-button class="btn btn-light" style="margin-left:10px;" @click="editFirmwareVisible = false;"><span>{{
          $t('upgradeManagement.cancel') }}</span></el-button>
        <!-- 确认  -->
        <el-button class="btn btn-dark editFirmwareBtn" style="margin-left:10px;" :loading="editFirmwareLoading"
          :disabled="editFirmwareLoading" @click="editFirmware()">
          <span>{{ $t('upgradeManagement.confirm') }}</span>
        </el-button>
      </div>
    </firmware-dialog>
    <!-- 智能升级提示 -->
    <firmware-dialog :visible.sync="intelligenceUpgradeTip"
      :class="{ 'showDialog': intelligenceUpgradeTip, 'hideDialog': !intelligenceUpgradeTip }" width="420px" noContentClose
      :title="$t('menu.intelligenceUpgrade')">
      <div slot="content">
        <div v-if="intelligenceUpgradeInfo.confirmMessage&&intelligenceUpgradeInfo.needConfirm">{{ intelligenceUpgradeInfo.confirmMessage }}</div>
        <div v-else>{{ $t('menu.intelligenceUpgradeTitle1') }}</div>
      </div>
      <div slot="footer">
        <!-- 取消  -->
        <el-button class="btn btn-light" style="margin-left:10px;" @click="intelligenceUpgradeTip = false;"><span>{{
          $t('upgradeManagement.cancel') }}</span></el-button>
        <!-- 确认  -->
        <el-button class="btn btn-dark editFirmwareBtn" style="margin-left:10px;" :loading="editFirmwareLoading"
          @click="confirmIntelligenceUpgrade()">
          <span>{{ $t('upgradeManagement.confirm') }}</span>
        </el-button>
      </div>
    </firmware-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import firmwareDialog from "@/components/dialognew";
import _ from "lodash";
export default {
  components: {
    firmwareDialog
  },
  data() {
    return {
      firName: '',//正在升级中的固件名称
      firDesc: '',//正在升级中的固件描述
      isLoading: false, // 表格加载
      destroyed: false, // 页面销毁标志
      _dataloggerOnlineTimer: null,
      _dataloggerOnlineStartTime: null,
      editFirmwareLoading: false, // 编辑固件提交按钮加载
      editFirmwareVisible: false, // 编辑固件对话框显隐
      editFirmwareForm: {
        note: "",
        deleteFlag: 0,
        versionNote: "",
        file: "",
        name: "",
        mode: 1,
      },
      editFirmwareRules: {
        name: [
          { required: true, message: this.$t("upgradeManagement.firmwareName_empty"), trigger: ['blur', 'change'] }
        ],
        versionNote: [
          { required: true, message: this.$t("upgradeManagement.firmwareVersion_empty"), trigger: ['blur', 'change'] }
        ],
      },
      dataLoggerInterval: null, // 用于保存queryProgressDataLogger的定时器ID
      keyProgressData: "",//数采器升级key
      waitingUpgradeText: this.$t("firmware.upgrade_wait"),
      waitingUpgradeVisible: false,//等待升级页面弹框
      dataloggerVer: null,//数采器版本
      progressErrCount: 0, // 进度请求错误计数器
      retryCount501: 0, // 501重试计数器
      has501: false, // 是否出现过501
      lastProgress: 0, // 记录上一次进度
      hideFlag: false, //德业域名显隐
      loadingPlas: false,
      maskBox: false,
      dialogVisible: false,
      dialogVisibleFelst: false,
      dialogVisibleFelstText: '',
      progressFlag: null,
      upgcLAS: null,
      uploadTotalSize: "", //文件的总大小
      uploadNowSize: "0.00", //现在正在上传的大小
      // buttonUpgrade: true,
      progress: 0,
      firmwareName: "",
      keyProgress: "",
      progressUp: false,
      selectedArrData: [],
      desc: "",
      upgradedata: {},
      dataTable: [],
      // 增加固件
      dialogAdd: false,
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      upgradeDeviceVisible: false,
      upgradeButtonDisable: false,
      intelligenceUpgradeTip:false,
      intelligenceUpgradeInfo:{
        firmwareId:'',
        firmwareName:'',
        needConfirm:false,
        confirmMessage:'',
        qlfuResponse:'',
      },
      searchrecharge: {
        firmwaretype: "1",
        brate: "0"
      },
      firmwaretypelist: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "1"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "2"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "3"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "4"
        }
      ],
      firmwaretypelist1: [
        {
          //通用固件
          id: 11,
          label: this.$t("device.universal_firmware"),
          value: "0"
        },
        {
          //通讯版固件
          id: 12,
          label: this.$t("device.communication_firmware"),
          value: "1"
        },
        {
          //控制版固件1
          id: 13,
          label: this.$t("device.control_firmware1"),
          value: "2"
        },
        {
          //控制版固件2
          id: 14,
          label: this.$t("device.control_firmware2"),
          value: "3"
        },
        {
          //BMS固件
          id: 15,
          label: this.$t("device.control_firmware_bms"),
          value: "4"
        },
        {
          //SlavMCU固件
          id: 16,
          label: this.$t("device.control_firmware_slavmcu"),
          value: "5"
        }
      ],
      bratelist: [
        {
          //默认
          label: this.$t("device.default"),
          value: "0"
        },
        {
          label: 1200,
          value: "1200"
        },
        {
          label: 2400,
          value: "2400"
        },
        {
          label: 4800,
          value: "4800"
        },
        {
          label: 9600,
          value: "9600"
        },
        {
          label: 19200,
          value: "19200"
        },
        {
          label: 38400,
          value: "38400"
        },
        {
          label: 57600,
          value: "57600"
        },
        {
          label: 115200,
          value: "115200"
        }
      ],
      firmware1: "",
      flag: false,
      dataloggerPercentageValue:0, //数采器升级进度
      dataloggerPercentageFlag:false, //数采器升级进度条显隐
      dataloggerPercentageMarkFlag:'', //数采器升级进度值标识判断是否关闭定时器
    };
  },
  computed: {
    ...mapGetters({
      deviceInfo: "getDeviceInfo",
      upgradeUPG: "getUpgradeUPG"
    }),
    deviceStatus() {
      // return this.$filter.deviceStatus[this.deviceInfo.status]
      return this.$filter.deviceStatusShadow[this.deviceInfo.status];
    }
  },
  created() {
    this.getQueryDeviceFirmwareUpgradeLastRecord();
    this.getQueryFiremware();
    this.queryDeviceUpgradeStatus();
    this.getUpgFirmwaretypeNom();
    this.getDataloggerVersion();
  },
  mounted() { },
  beforeDestroy() {
    this.destroyed = true;
    clearTimeout(this.interval);// 在组件销毁之前清除定时器
    this.interval = null;
    this.progressUp = false;
    this.clearDataLoggerInterval()
  },
  watch: {
    // waitingUpgradeVisible (val) {
    //   if (!val) {
    //     this.clearDataLoggerInterval()
    //   }
    // },
  },
  methods: {
    // 二次确认智能升级
    confirmIntelligenceUpgrade(){
      this.submitIntelligenceUpgrade(true,this.intelligenceUpgradeInfo.firmwareName,this.intelligenceUpgradeInfo.firmwareId)
      this.intelligenceUpgradeTip=false
    },
    // 智能升级
    intelligenceUpgrade(){
      this.intelligenceUpgradeInfo={
        firmwareId:'',
        firmwareName:'',
        needConfirm:false,
        confirmMessage:'',
        qlfuResponse:'',
      }
      let params = {
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
      }
      this.$request.postUPG("/upg/api/auth/web/device/firmware/adaptive/detect",params).then(res => { 
        if (res.code==0) {
          if (res.data&&res.data.firmwareName) {
            this.intelligenceUpgradeInfo=res.data
            if (this.intelligenceUpgradeInfo.needConfirm) {
              this.intelligenceUpgradeTip=true
            }else{
              this.submitIntelligenceUpgrade(true,res.data.firmwareName,res.data.firmwareId)
            }
          }
          if (!res.data.firmwareName) {
            this.$message.error(this.$t("menu.intelligenceUpgradeTitle"));
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 智能升级提交
    submitIntelligenceUpgrade(upgrade,firmwareName,firmwareId){
      let params = {
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
        firmwareId: firmwareId,
        adaptiveUpgrade: upgrade,
        adaptiveFirmwareName: firmwareName,
      }
      this.$request.postUPG("/upg/api/auth/web/device/upgradeTransmission",params).then(res => { 
        if (res.code==0) {
          this.keyProgress = res.data.key;
          this.buttonUpgrade = false;
          this.maskBox = true;
          this.flag = true;
          this.upgradeButtonDisable = true;
          this.queryProgress();
          this.$message.success(this.$t("device.Upgrading"));
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 获取数采器版本号
    getDataloggerVersion() {
      let params = {
        pn: this.deviceInfo.pn
      }
      // 返回Promise，支持async/await和then链式调用
      return this.$request.get("webQueryCollectorsEs", params)
        .then((res) => {
          if (res.err == 0) {
            this.dataloggerVer = res.dat.collector[0].fireware
            return res;
          } else {
            return Promise.reject(res);
          }
        });
    },
    // 编辑固件弹窗
    editFirmwareDialog(info) {
      this.editFirmwareVisible = true
      this.editFirmwareForm.name = info.firmwareName
      this.editFirmwareForm.versionNote = info.firmwareVersion
      this.editFirmwareForm.note = info.note
      this.editFirmwareForm.id = info.id
    },
    // 编辑固件提交
    editFirmware() {
      if (this.editFirmwareLoading) return;
      this.$refs.editFirmwareForm.validate(valid => {
        if (!valid) return false
        this.editFirmwareLoading = true;
        let action = "/upg/api/auth/web/device/firmware/" + this.editFirmwareForm.id
        let params = {
          deleteFlag: this.editFirmwareForm.deleteFlag,
          firmwareName: this.editFirmwareForm.name,
          firmwareVersion: this.editFirmwareForm.versionNote,
          note: this.editFirmwareForm.note,
          upgradeMode: this.editFirmwareForm.mode,
          i18n: this.$lang.currentLang,
        }
        this.$request.put(action, params).then((res) => {
          this.editFirmwareLoading = false;
          if (res.code == 0) {
            this.$message.success(this.$t("upgradeManagement.eidt_success"))
            this.editFirmwareVisible = false
            this.getQueryFiremware()
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
          this.editFirmwareLoading = false;
        });
      })
    },
    //删除固件进入界面按钮
    deleteFirmware(info) {
      this.dialogVisible = true;
      this.upgcLAS = info;
    },
    //删除固件
    configdelete(VAL) {
      this.$request.delete(`/upg/api/auth/web/device/firmware/${this.upgcLAS.id}`)
        .then(res => {
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.deleteSuc"));
            setTimeout(() => {
              this.getQueryFiremware();
            }, 500);
            this.dialogVisible = false;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    getUpgFirmwaretypeNom() {
      this.$request.getUPG(`/upg/api/auth/web/device/upgradeType`).then(res => {
        if (res.code == 0) {
          if (res.data.items && res.data.items.length != 0) {
            var arrList = []
            res.data.items.forEach((element, index) => {
              if (element.id == 3 && this.deviceInfo.otaLabel == 1) {
                
              }else{
                
                arrList.push({
                  value: element.id,
                  label: element.typeName,
                  id: element.id,
                })
              }
            })
            this.firmwaretypelist = arrList
            this.searchrecharge.firmwaretype = this.firmwaretypelist[0].value
          }
        }
      });
    },
    // 查询设备升级状态
    queryDeviceUpgradeStatus(info) {
      let params = {
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devcode: this.deviceInfo.devcode,
        devaddr: this.deviceInfo.devaddr,
      }
      //   if (this.upgradeUPG.upgradeUPG) {
      // 接入UPG升级
      this.$request
        .getUPG("/upg/api/auth/web/device/upgradeStatus", params)
        .then(res => {
          if (res.code == 0) {
            if (res.data.status == 0) {
              this.firName = res.data.firmwareName;
              this.firDesc = res.data.versionNote;
              this.keyProgress = res.data.key;
              this.queryProgress();
              let progress =
                this.$filter.formatNum(res.data.progress / 10, 0) - 0;
              this.progress = progress;
              this.flag = true;
              this.maskBox = true;
              this.upgradeButtonDisable = true;
            }
          }
        });
    },
    submitBox() {
      if (this.selectedArrData.length == 0) {
        this.$message.error(this.$t("datalogger.file_fist"));
      } else {
        // this.getDataloggerVersion()
        this.upgradeDeviceVisible = true;
        this.firmware1 = this.selectedArrData[0].firmwareName;
      }
    },
    //德业域名
    showHides() {
      var hostname = window.location.hostname;
      if (hostname == "deye.dessmonitor.com") {
        this.hideFlag = true;
      }
    },
    //取消升级
    upgradeCancel: _.debounce(function () {
      // if(this.upgradeUPG.upgradeUPG){
      let parmas = {
        pn: this.$store.state.device.pn,
        key: this.keyProgress
      };
      this.$request
        .putUPG(`/upg/api/auth/web/device/upgradeCancel`, parmas)
        .then(res => {
          this.upgradeButtonDisable = false;
          if (res.code == 0) {
            this.$message.success(this.$t("firmware.CancelUpgradeSuc"));
            // this.$message.success(this.$t("firmware.CancelUpgradeSuc11"));
            this.flag = false;
            setTimeout(() => {
              this.getQueryDeviceFirmwareUpgradeLastRecord();
            }, 500);
            clearTimeout(this.interval);
            this.interval = null;
            this.clear501Params()
            this.progressUp = false;
            this.maskBox = false;
          }
          // else if (res.code == 3 || res.code == 1) {
          //   this.upgradeDeviceVisible = false;
          // } 
          else {
            this.$message.error(res.message)
            // this.$message.error();
          }
        });
    }, 800),
    // 确认固件升级
    submitUpgradeDatalogger: _.debounce(async function () {
      try {
        let firNameCheck = this.selectedArrData[0].firmwareName
        if (firNameCheck&&/^[AB]/i.test(firNameCheck)&&this.deviceInfo.otaLabel==1) {
          this.$message.error(this.$t("firmware.error2"));
          return
        }
        const versionRes = await this.getDataloggerVersion();
        this.tosubmitUpgradeDatalogger()
      } catch (err) {
        // 处理异常
        this.dataloggerVer = null;
        this.tosubmitUpgradeDatalogger()
      }
    }, 300),
    tosubmitUpgradeDatalogger() {
      this.flag = true;
      this.progress = 0;
      // 重置计数器，避免上次错误影响本次升级
      this.progressErrCount = 0;
      this.clearDataLoggerInterval()
      //   this.$message.success(this.$t("firmware.upgrading1"));
      if (this.selectedArrData.length == 0) {
        this.$message.error(this.$t("datalogger.file_fist"));
      } else {
        // 只判断第一个选中的固件包
        const fileSize = this.selectedArrData[0].fileSize || 0;
        const sizeKB = fileSize / 1024;
        const sizeRemainder = fileSize % 1024;
          // this.dataloggerVer == '8.50.18.3' &&
          // sizeKB <= 600 &&
          // sizeRemainder <= 128
        if (
          this.dataloggerVer == '8.50.18.3'||this.dataloggerVer == '8.50.12.3'
        ) {
          this.waitingUpgradeVisible = true;
          this.waitingUpgradeText = this.$t("firmware.upgrade_wait");
          // setTimeout(() => {
          //   // 升级数采器
          //   this.toUpgradeDatalogger();
          // }, 500);
          this.getDataloggerUpgradeStatus()
        } else {
          // 重置计数器，避免上次错误影响本次升级
          this.progressErrCount = 0;
          // 升级设备
          this.toUpgradeDevice();
        }
      }
    },
    getDataloggerUpgradeStatus() {
      let params = {
        pn: this.$store.state.device.pn,
      };
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeStatus", params).then(res => {
        if (res.code == 0) {
          if (res.data.status == 0) {
            // let progress =this.$filter.formatNum(res.data.progress / 10, 0) - 0;
            let progress = res.data.progress - 0;
            if (progress >= 1000) {
              setTimeout(() => {
                // 30秒后判断maskBox或loadingPlas
                if (this.maskBox === true || this.loadingPlas === true) {
                  // 正在升级或加载中，不执行升级
                  return;
                }
                // this.retryCount501 = 0;
                // this.waitingUpgradeVisible = false;
                // this.toUpgradeDevice();
                this.getDataloggerOnlineStatus();
              }, 30000);
              return;
            }
            this.keyProgressData = res.data.key;
            this.queryProgressDataLogger();
          } else {
            setTimeout(() => {
              // 升级数采器
              this.toUpgradeDatalogger();
            }, 500);
          }
        }
      });
    },
    // 获取数采器在线状态
    /**
     * 轮询获取数采器在线状态，五分钟内每次接口响应后再查，五分钟后未上线弹窗提示
     */
    getDataloggerOnlineStatus() {
      if (this._dataloggerOnlineTimer) {
        clearTimeout(this._dataloggerOnlineTimer);
        this._dataloggerOnlineTimer = null;
      }
      if (this._dataloggerOnlineStartTime == null) {
        this._dataloggerOnlineStartTime = Date.now();
      }
      const params = {
        pn: this.$store.state.device.pn,
        devaddr: this.$store.state.device.devaddr,
        cmd: '41 54 2B 48 54 42 54 3F 0D 0A'
      };
      if (this.destroyed) return;
      this.$request.get("sendCmdToDevice", params)
        .then((res) => {
          if (res.err === 0) {
            // 已上线，清理定时器，重置时间
              this.dataloggerPercentageValue=100
              this._dataloggerOnlineStartTime = null;
              this._dataloggerOnlineTimer = null;
              this.retryCount501 = 0;
              this.waitingUpgradeVisible = false;
              this.toUpgradeDevice();
              this.dataloggerPercentageFlag=false
              return;
          }
          // 未上线，判断是否超时
          const now = Date.now();
          if (now - this._dataloggerOnlineStartTime < 5 * 60 * 1000) {
            // 未超5分钟，继续轮询，接口响应后再查
            this._dataloggerOnlineTimer = setTimeout(() => {
              this.getDataloggerOnlineStatus();
            }, 2000);
          } else {
            // 超过5分钟还未上线，弹窗提示
            this._dataloggerOnlineStartTime = null;
            this._dataloggerOnlineTimer = null;
            this.waitingUpgradeVisible = true;
            this.dataloggerPercentageFlag=false
            this.waitingUpgradeText = this.$t("firmware.upgrade_wait1");
          }
        });
    },
    // 数采器升级
    toUpgradeDatalogger() {
      let params = {
        pn: this.$store.state.device.pn,
        // firmwareId: '696e068bc01fc030eb8e7a50'
        firmwareId: this.dataloggerVer == '8.50.12.3' ? '6970be6b39df251b2caf1e1c' : '6970be9739df251b2caf1e1d'
      };
      this.$request.postUPG("/upg/api/auth/web/shineDess/collector/firmwareUpgradeCollector", params).then(res => {
        if (res.code == 0) {
          if (res.data.ret == 0) {
            this.keyProgressData = res.data.key;
            this.dataloggerPercentageFlag=true
            this.dataloggerPercentageValue=0
            this.queryProgressDataLogger();
          } else if (res.data.ret == 1) {
            this.waitingUpgradeVisible = true;
            this.waitingUpgradeText = this.$t("firmware.colOffline");
            this.dataloggerPercentageFlag=false
          } else if (res.data.ret == 2) {
            this.waitingUpgradeVisible = true;
            this.waitingUpgradeText = this.$t("firmware.colOffline");
            this.dataloggerPercentageFlag=false
          } else if (res.data.ret == 3) {
            this.waitingUpgradeVisible = true;
            this.waitingUpgradeText = this.$t("firmware.colUpgrading");
            this.dataloggerPercentageFlag=false
          } else {
            this.waitingUpgradeVisible = true;
            this.waitingUpgradeText = this.$t("firmware.colOffline");
            this.dataloggerPercentageFlag=false
          }
        } else {
          this.waitingUpgradeVisible = true;
          // this.waitingUpgradeText = this.$t("firmware.upgrade_quit2");
           this.waitingUpgradeText = res.message;
           this.dataloggerPercentageFlag=false
        }
      }).catch(err => {
        this.waitingUpgradeVisible = true;
        this.waitingUpgradeText = this.$t("errCode.2");
        this.dataloggerPercentageFlag=false
      });
    },
    queryProgressDataLogger() {
      let params = {
        pn: this.$store.state.device.pn,
        key: this.keyProgressData
      };
      const fetchProgresss = () => {
        if (this.destroyed) return;
        // 如果已经到达100%进度，不再发起新的请求
        if (this.dataloggerPercentageMarkFlag >= 1000) {
          return;
        }
        this.$request.getUPG("/upg/api/auth/web/shineDess/collector/queryCollectorFirmwareUpgradeProgress", params)
          .then(res => {
            if (this.destroyed) return;
            // 再次检查是否已经达到100%，防止竞态条件
            if (this.dataloggerPercentageMarkFlag >= 1000) {
              return;
            }
            if (res.code == 0) {
              if (res.data.status == 0) {
                let progress = res.data.progress - 0;
                this.dataloggerPercentageValue=Math.floor(progress/10-1)<0?0:Math.floor(progress/10-1)
                if (progress >= 1000) {
                  this.dataloggerPercentageMarkFlag = res.data.progress;
                  // 立即清除定时器，防止后续请求继续轮询
                  this.clearDataLoggerInterval();
                  setTimeout(() => {
                    // 30秒后判断maskBox或loadingPlas
                    if (this.maskBox === true || this.loadingPlas === true) {
                      // 正在升级或加载中，不执行升级
                      return;
                    }
                    // this.retryCount501 = 0;
                    // this.waitingUpgradeVisible = false;
                    // this.toUpgradeDevice();
                    this.getDataloggerOnlineStatus();
                  }, 30000);
                  return;
                }
                if (!this.flag) return;
                this.dataLoggerInterval = setTimeout(fetchProgresss, 2000);
              } else {
                // 如果已经达到100%，忽略后续的状态变化
                if (this.dataloggerPercentageMarkFlag >= 1000) {
                  return;
                }
                this.progressErrCount++;
                if (this.progressErrCount <= 5) {
                  if (!this.flag) return;
                  this.dataLoggerInterval = setTimeout(fetchProgresss, 2000);
                } else {
                  this.waitingUpgradeVisible = true;
                  this.waitingUpgradeText = this.$t("firmware.upgradeSq_fail");
                  //  this.waitingUpgradeText = res.message;
                  this.progressErrCount = 0;
                  this.dataloggerPercentageFlag=false
                }
                return;
              }
            } else {
              // 如果已经达到100%，忽略后续的错误响应
              if (this.dataloggerPercentageMarkFlag >= 1000) {
                return;
              }
              this.progressErrCount++;
              if (this.progressErrCount <= 5) {
                this.dataLoggerInterval = setTimeout(fetchProgresss, 2000);
              } else {
                this.waitingUpgradeVisible = true;
                // this.waitingUpgradeText = this.$t("firmware.upgrade_quit2");
                     this.waitingUpgradeText = res.message;
                this.progressErrCount = 0;
                this.dataloggerPercentageFlag=false
              }
            }
          })
          .catch(err => {
            // 如果已经达到100%，忽略错误
            if (this.dataloggerPercentageMarkFlag >= 1000) {
              return;
            }
            this.progressErrCount++;
            if (this.progressErrCount <= 5) {
              this.dataLoggerInterval = setTimeout(fetchProgresss, 2000);
            } else {
              this.waitingUpgradeVisible = true;
              this.waitingUpgradeText = this.$t("errCode.2");
              this.progressErrCount = 0;
              this.dataloggerPercentageFlag=false
            }
          });
      }
      fetchProgresss();
    },
    // 清除queryProgressDataLogger的定时器和getDataloggerOnlineStatus的定时器
    clearDataLoggerInterval() {
      // 数采器升级进度
      if (this.dataLoggerInterval) {
        clearTimeout(this.dataLoggerInterval);
        this.dataLoggerInterval = null;
      }
      // 数采器在线
      if (this._dataloggerOnlineTimer) {
        clearTimeout(this._dataloggerOnlineTimer);
        this._dataloggerOnlineTimer = null;
      }
    },
    // 设备升级
    toUpgradeDevice() {
      this.firName = this.selectedArrData[0].firmwareName;
      this.firDesc = this.selectedArrData[0].note;
      this.firmwareName = this.selectedArrData[0].id;
      this.uploadTotalSize = this.$filter.formatNum(
        this.selectedArrData.fileSize / (1024 * 1024),
        2
      );
      let firNameCheck = this.selectedArrData[0].firmwareName
      if (firNameCheck&&/^[AB]/i.test(firNameCheck)&&this.deviceInfo.otaLabel==1) {
        this.$message.error(this.$t("firmware.error2"));
        return
      }
      let params = {
        pn: this.$store.state.device.pn,
        devaddr: this.$store.state.device.devaddr,
        devcode: this.$store.state.device.devcode,
        sn: this.$store.state.device.sn,
        firmwareId: this.firmwareName,
        firmwareType: this.searchrecharge.firmwaretype,
        baudrate: this.searchrecharge.brate
      };
      // if (this.upgradeUPG.upgradeUPG) {
      // 接入UPG升级
      this.loadingPlas = true
      this.upgradeDeviceVisible = false;
      this.waitingUpgradeVisible = true;
      this.waitingUpgradeText = this.$t("firmware.UpgradeStarting");
      this.$request
        .postUPG("/upg/api/auth/web/device/upgradeTransmission", params, null, { timeout: 90000 })
        .then(res => {
          this.loadingPlas = false
          if (res.code == 0) {
            if (res.data.status == 0) {
              this.keyProgress = res.data.key;
              // this.buttonUpgrade = false;
              this.maskBox = true;
              // this.upgradeDeviceVisible = false;
              this.waitingUpgradeVisible = false;
              this.upgradeButtonDisable = true;
              // this.$message.success(this.$t("datalogger.update_suc"));
              this.$message.success(this.$t("device.Upgrading"));
              // this.upgradeDeviceSucVisible = true;
              this.queryProgress();
              // this.upgradeDataloggerVisible = false;
              // this.dialogAdd = false;
            } else if (res.data.status == 1) {
              // this.$message.error(this.$t("device.System_Failed"));
              // this.dataloggerTipMsg = this.$t("device.System_Failed");
              // this.upgradeDeviceFailVisible = true;
              this.waitingUpgradeText = this.$t("device.System_Failed");
            } else if (res.data.status == 2) {
              // this.$message.error(this.$t("device.Device_Offline"));
              // this.dataloggerTipMsg = this.$t("device.Device_Offline");
              // this.upgradeDeviceFailVisible = true;
              this.waitingUpgradeText = this.$t("device.Device_Offline");
            } else if (res.data.status == 3) {
              // this.$message.error(this.$t("device.In_Upgrading"));
              // this.dataloggerTipMsg = this.$t("device.In_Upgrading");
              // this.upgradeDeviceFailVisible = true;
              this.waitingUpgradeText = this.$t("device.In_Upgrading");
            }
          } else {
            // this.$message.error(res.message);
            // this.dataloggerTipMsg = this.$t(`errCode.${res.err}`);
            // this.upgradeDeviceFailVisible = true;
            // this.upgradeDeviceVisible = false;
            this.waitingUpgradeText = res.message;
              this.upgradeButtonDisable = false;
          }
        }).catch(err => {
           this.loadingPlas = false
          //  this.upgradeDeviceVisible = false;
          //  this.$message.error(this.$t("errCode.2"));
            this.waitingUpgradeText = this.$t("errCode.2");
        });
    },
    progressText(progress) {
      return progress === 100 ? this.$t("datalogger.finish") : `${progress}%`;
    },
    // 查询升级进度
    queryProgress() {
      this.progressUp = true;
      this.progerssComplete = false;
      //   if (this.upgradeUPG.upgradeUPG) {
      // // 接入UPG升级服务
      // let params = {
      //   pn: this.$store.state.device.pn,
      //   // devaddr: this.$store.state.device.devaddr,
      //   // devcode: this.$store.state.device.devcode,
      //   // sn: this.$store.state.device.sn,
      //   key: this.keyProgress
      // };
      // 如果已存在定时器，先清除
      if (this.interval) {
        clearTimeout(this.interval);
        this.interval = null;
      }
      // 501重试相关变量初始化
      if (this.retryCount501 === undefined) {
        this.retryCount501 = 0;
      }
      if (this.has501 === undefined) {
        this.has501 = false;
      }
      const fetchProgress = () => {
        if (this.destroyed) return;
        let params = {
          pn: this.$store.state.device.pn,
          key: this.keyProgress
        };
        // this.interval = setInterval(() => {
        this.$request
          .getUPG("/upg/api/auth/web/device/upgradeProgressByKey", params)
          .then(res => {
            if (this.destroyed) return;
            if (res.code == 0) {
              this.progressFlag = res.data.status;
              let progress = this.$filter.formatNum(res.data.progress / 10, 0) - 0;
              let progress501Or = this.$filter.formatNum(res.data.progress, 0) - 0;
              // 501重试机制
              if (progress501Or === 501 && this.flag) {
                this.has501 = true;
              }
              // 501阶段遇到status=2，重试次数未超过2次，每次都能重试
              if (this.has501 && progress501Or === 501 && res.data.status == 2 && this.retryCount501 < 2 && this.firmwareName) {
                this.retryCount501++;
                // 静默重试，页面进度停留在501
                this.progress = progress;
                this.uploadNowSize = this.$filter.formatNum((this.uploadTotalSize * 501) / 100, 2);
                // 延迟15s再去重试升级
                setTimeout(() => {
                  if (this.destroyed) return;
                  this.retryUpgradeDevice(() => {
                    this.interval = setTimeout(fetchProgress, 2000);
                  });
                }, 15000);
                return;
              }
              // 501阶段遇到其它非0非2，直接走原有错误处理逻辑
              if (this.has501 && progress501Or === 501 && res.data.status !== 0 && res.data.status !== 2) {
                this.progressErr(res.data.step);
                return;
              }
              // 501重试后，只有进度大于501才恢复页面进度和重置重试计数
              if (this.has501 && progress501Or === 501 && this.retryCount501 >= 2) {
                // 超过2次重试后，遇到status=2也不再重试，走原有错误处理
                if (res.data.status == 2) {
                  this.progressErr(res.data.step);
                  return;
                }
              }
              if (this.has501 && progress501Or > 501) {
                this.clear501Params()
              }
              // 正常进度处理
              if (res.data.status == 0) {
                // 501静默重试期间，重试后progress<=501页面进度保持501，只有progress>501才恢复
                if (!(this.retryCount501 > 0 && progress501Or <= 501)) {
                  this.progress = progress;
                  this.uploadNowSize = this.$filter.formatNum((this.uploadTotalSize * progress) / 100, 2);
                }
                // 重置计数器，避免上次错误影响本次升级
                this.progressErrCount = 0;
                if (this.progress >= 100) {
                  clearTimeout(this.interval);
                  this.getQueryDeviceFirmwareUpgradeLastRecord();
                  this.interval = null;
                  this.clear501Params()
                  this.progressUp = false;
                  this.uploadNowSize = this.uploadTotalSize;
                  this.progerssComplete = true;
                  this.progressSuc();
                  setTimeout(() => {
                    // this.upgradeDataloggerVisible = false;
                    this.maskBox = false;
                    this.upgradeButtonDisable = false;
                    // this.buttonUpgrade = true;
                  }, 500);
                  this.lastProgress = progress;
                  return;
                }
                if (!this.flag) return;
                this.interval = setTimeout(fetchProgress, 2000);
              } else {
                this.progressErrCount++;
                if (this.progressErrCount <= 5) {
                  // 5次内，继续请求queryProgress
                  if (!this.flag) return;
                  this.interval = setTimeout(fetchProgress, 2000);
                } else {
                  this.progressErr(res.data.step);
                  this.progressErrCount = 0;
                }
              }
              this.lastProgress = progress;
            } else {
              // 增加重试机制，最多5次
              this.progressErrCount++;
              if (this.progressErrCount <= 5) {
                // 5次内，继续请求queryProgress
                if (!this.flag) return;
                this.interval = setTimeout(fetchProgress, 2000);
              } else {
                this.$message.error(res.message);
                clearTimeout(this.interval);
                this.interval = null;
                this.maskBox = false;
                this.progressUp = false;
                // this.buttonUpgrade = true;
                this.clear501Params()
              }
            }
          }).catch(() => {
            // 网络异常也重试
            this.progressErrCount++;
            if (this.progressErrCount <= 5) {
              if (!this.flag) return;
              this.interval = setTimeout(fetchProgress, 2000);
            } else {
              this.progressErrCount = 0;
              // 异常也清除定时器
              clearTimeout(this.interval);
              this.interval = null;
              this.maskBox = false;
              this.progressUp = false;
              this.clear501Params()
            }
          });
        // }, 2000);
      }
      fetchProgress();
    },
    // 清空501重试相关参数
    clear501Params() {
      this.retryCount501 = 0; // 501重试计数器
      this.has501 = false // 是否出现过501
      this.lastProgress = 0; // 记录上一次进度
    },
    // 501重试时重新调用升级接口，静默
    retryUpgradeDevice(cb) {
      let params = {
        pn: this.$store.state.device.pn,
        devaddr: this.$store.state.device.devaddr,
        devcode: this.$store.state.device.devcode,
        sn: this.$store.state.device.sn,
        firmwareId: this.firmwareName,
        firmwareType: this.searchrecharge.firmwaretype,
        baudrate: this.searchrecharge.brate,
      };
      this.$request.postUPG("/upg/api/auth/web/device/upgradeTransmission", params, null, { timeout: 90000 }).then(res => {
        if (res.code == 0 && res.data.status == 0) {
          this.keyProgress = res.data.key;
          // 不提示，静默
        } else {
          // 失败也不提示，静默
        }
        if (typeof cb === 'function') cb();
      }).catch(() => {
        if (typeof cb === 'function') cb();
      });
    },
    progressSuc() {
      if (this.flag) {
        this.$message.success(this.$t("device.Update_Completed"));
        this.dialogVisibleFelst = true
        this.dialogVisibleFelstText = this.$t("device.Update_Completed")
        this.flag = false;
      }
    },
    progressErr(val) {
      if (this.flag) {
        this.dialogVisibleFelst = true;
        if (this.progressFlag == 1) {
          this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit1");
        } else if (this.progressFlag == 2) {
          this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit2");
        } else if (this.progressFlag == 3) {
          this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit3");
        } else if (this.progressFlag == 4) {
          this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit4");
        } else if (this.progressFlag == 5) {
          this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit2");
          // this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit5");
        } else if (this.progressFlag == 6) {
          this.dialogVisibleFelstText = val;
        } else{
          // 该死的保底机制
          this.dialogVisibleFelstText = this.$t("firmware.upgrade_quit2");
        }
        this.flag = false;
        this.getQueryDeviceFirmwareUpgradeLastRecord();
        clearTimeout(this.interval);
        this.interval = null;
        this.clear501Params()
        this.progressUp = false;
        this.maskBox = false;
        // this.buttonUpgrade = true;
      }
    },
    //后退
    clickClosepage() {
      this.$store.commit("saveIsShow", 1);
      this.$store.state.event.foldGeneralSidebarNew = true;
    },
    //单选固件包
    handleSelectionChange(selection) {
      this.selectedArrData = selection;
      if (selection.length > 1) {
        this.$refs.tableRef.clearSelection();
        this.$refs.tableRef.toggleRowSelection(selection.pop());
      }
    },
    //选中行变色
    isRed({ row }) {
      const checkIdList = this.selectedArrData.map(item => item.id);
      if (checkIdList.includes(row.id)) {
        return {
          backgroundColor: "rgba(48,208,150,0.35)"
        };
      }
    },
    cellClass(row) {
      if (row.columnIndex === 0 && row.rowIndex === 0) {
        return "tablemain";
      }
    },

    //最近一次升级记录查询
    getQueryDeviceFirmwareUpgradeLastRecord() {
      //UPG中无最近升级记录接口
      // console.log("查询最近一次升级记录")
      let params = {
        // pn:this.deviceInfo.pn
        pn: this.$store.state.device.pn,
        // devaddr: this.$store.state.device.devaddr,
        // devcode: this.$store.state.device.devcode,
        // sn: this.$store.state.device.sn
      };
      this.$request
        .getUPG("/upg/api/auth/web/device/queryLastDeviceUpgradeRecord", params)
        .then(res => {
          if (res.code == 0) {
            this.upgradedata = res.data;
            this.upgradedata.progress = res.data.progress / 10 + "%";
          }
          //  else {
          //   this.upgradedata = this.$t(`errCode.${res.err}`);
          // }
        });
    },
    // 查询固件列表
    getQueryFiremware() {
      // let timeoutFlag = false;
      // const timeout = setTimeout(() => {
      //   timeoutFlag = true;
      //   if (this.destroyed) return;
      //   this.$message.error(this.$t("errCode.2"));
      //   this.dataTable = [];
      //   this.isLoading = false;
      // }, 15000);
      this.isLoading = true;
      let parmas = {
        page: this.pagination.currentPage,
        pageSize: 50
      };
      // 接入UPG升级
      this.$request
        .getUPG("/upg/api/auth/web/device/firmwares", parmas)
        .then(res => {
          // clearTimeout(timeout);
          // if (timeoutFlag) return;
          if (res.code == 0) {
            res.data.items.forEach(item => {
              item.fileSize = (item.fileSize / 1024).toFixed(1);
            });
            this.dataTable = res.data.items;
            this.isLoading = false;
          } else {
            this.dataTable = [];
            this.isLoading = false;
          }
        });
    },
    //增加固件进入界面按钮
    addFirmware() {
      this.dialogAdd = true;
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
        this.desc = null;
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile(event) {
      // this.$refs.upload.clearFiles()
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("createPlant.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "s19") {
        this.$message.error(this.$t("firmware.error1"));
        return;
      }
      let parmas = {
        firmwareName: file.name,
        versionNote: "V1.0",
        deleteFlag: "0",
        upgradeMode: 1,
        note: this.desc
      };
      // let timeoutFlag = false;
      // const timeouts = setTimeout(() => {
      //   timeoutFlag = true;
      //   if (this.destroyed) return;
      //   this.$message.error(this.$t("errCode.2"));
      //   this.dialogAdd = false;
      // }, 15000);
      this.$request
        .uploadFirmware("/upg/api/auth/web/device/firmware", file, parmas)
        .then(res => {
          // clearTimeout(timeouts);
          // if (timeoutFlag) return;
          if (res.code === 0) {
            this.$message.success(this.$t("createPlant.uploadSuccess"));
            // this.getData();
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else if (res.err === 6) {
            this.$message.error(this.$t("firmware.error1"));
            // 关闭二次弹窗
            this.dialogAdd = false;
          } else {
            this.$message.error(res.message);
            // 关闭二次弹窗
            this.dialogAdd = false;
          }
          setTimeout(() => {
            this.getQueryFiremware();
          }, 500);
        });
    },
    //点击确定时友情提示让其上传固件文件
    warningTipButton() {
      this.$message.warning(this.$t("firmware.uploadTips"));
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.deviceupgrade {
    width: 100%;
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;

  .upload-input {
    display: none;
  }

  /deep/ .el-loading-mask {
    background: rgba(0, 0, 0, 0.295) !important;
    z-index: 99 !important;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  /deep/.editFirmwareBtn .el-icon-loading {
    font-size: 14px;
  }

  // 上传固件弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }
  }

  /deep/.el-icon-loading {
    font-size: 28px;
  }

  /deep/.el-table tr {
    background-color: #222d35;
  }

  /deep/.el-table th.is-leaf {
    border-right: 1px solid rgba(102, 102, 102, 0.5);
    border-bottom: 1px solid rgba(102, 102, 102, 0.5);
  }

  /deep/.el-table td {
    border-right: 1px solid rgba(102, 102, 102, 0.5);
    border-bottom: 1px solid rgba(102, 102, 102, 0.5);
  }

  /deep/.el-table__body tr.hover-row td {
    background-color: transparent;
  }

  /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
    border-radius: 0;
    background: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  /deep/ .el-table .el-table__header-wrapper .cell .el-checkbox__inner {
    display: none;
  }

  /deep/.el-table th>.cell {
    font-weight: 400;
  }

  .upgradeInfo {
    height: 136px !important;
    margin-bottom: 12px;
    box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.1);
    display: flex;
    height: 100%;

    .closepage {
      background-color: rgba(255, 255, 255, 0.05);
      width: 63px;
      height: 136px;
      background-image: url("../../../../assets/img/general/arrow_left.png");
      background-size: 24px 24px;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;
    }

    .xinxi {
      width: 100%;
      height: 136px;
      color: #fff;
      background-color: #222d35;

      .top-info {
        display: flex;
        align-items: center;

        .label {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          height: 56px;

          // 设备状态带阴影
          .status-icon-shadow {
            width: 14px;
            height: 14px;
            border-radius: 7px;
            margin: 0 14px 0 18px;
          }

          .status-normal-shadow {
            background-color: rgba(48, 236, 112, 1);
            box-shadow: 1px 1px 3px rgba(48, 236, 112, 1);
          }

          .status-offline-shadow {
            background-color: rgba(183, 183, 183, 1);
            box-shadow: 1px 1px 3px rgba(183, 183, 183, 1);
          }

          .status-fault-shadow {
            background-color: rgba(255, 62, 62, 1);
            box-shadow: 1px 1px 3px rgba(255, 62, 62, 1);
          }

          .status-standby-shadow {
            background-color: rgba(73, 222, 255, 1);
            box-shadow: 1px 1px 3px rgba(73, 222, 255, 1);
          }

          .status-warning-shadow {
            background-color: rgba(236, 150, 48, 1);
            box-shadow: 1px 1px 3px rgba(236, 150, 48, 1);
          }
        }
      }

      .infobox {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 40px 40px;
        grid-template-areas:
          "a11 a12 a13 a14"
          "a21 a22 a23 a24";

        .gCell11 {
          grid-area: a11;
        }

        .gCell12 {
          grid-area: a12;
        }

        .gCell13 {
          grid-area: a13;
        }

        .gCell14 {
          grid-area: a14;
        }

        .gCell21 {
          grid-area: a21;
        }

        .gCell22 {
          grid-area: a22;
        }

        .gCell23 {
          grid-area: a23;
        }

        .gCell24 {
          grid-area: a24;
        }

        .cell {
          line-height: 40px;
          padding: 0px 16px;
          box-shadow: none;
          // color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          border-right: 1px solid rgba(102, 102, 102, 0.5);
        }

        .cell1 {
          line-height: 40px;
          padding: 0px 16px;
          box-shadow: none;
          // color: rgba(255, 255, 255, 0.8);
          font-size: 14px;
          // border-right: 1px solid #000;
        }

        .light {
          background: rgb(43, 56, 66);
        }

        .data {
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .dark {
          background: rgb(34, 45, 53);
        }
      }
    }
  }
  .table {
    flex: 1;
    overflow: auto;
  }

  .infobox1 {
    grid-template-columns: 1fr 0 1fr 1fr;
    width: 100%;
    color: #fff;
    display: grid;
    // grid-template-columns: 1fr 1fr 1fr 1fr;
    // grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    // grid-template-columns: 100px 100px 100px 100px;
    grid-template-rows: 46px 40px 48px;
    grid-template-areas:
      "b1 b1 b1 b1"
      "b11 b12 b13 b14"
      "b21 b22 b23 b24"
      "b2 b2 b2 b2";

    .bTitle1 {
      grid-area: b1;
      line-height: 46px;
      padding: 0 0 0 20px;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      background-color: #41505a;
    }

    .bTitle2 {
      margin-top: 12px;
      position: relative;
      grid-area: b2;
      line-height: 46px;
      padding: 0 0 0 20px;
      font-size: 16px;
      font-weight: 700;
      color: #fff;
      background-color: #41505a;
      display: flex;
      justify-content: space-between;
    }

    .bCell11 {
      grid-area: b11;
    }

    .bCell12 {
      grid-area: b12;
    }

    .bCell13 {
      grid-area: b13;
    }

    .bCell14 {
      grid-area: b14;
    }

    .bCell21 {
      grid-area: b21;
    }

    .bCell22 {
      grid-area: b22;
    }

    .bCell23 {
      grid-area: b23;
    }

    .bCell24 {
      grid-area: b24;
    }

    .cell {
      line-height: 40px;
      padding: 0px 16px;
      box-shadow: none;
      // color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      border-right: 1px solid rgba(102, 102, 102, 0.5);
    }

    .cell1 {
      line-height: 40px;
      padding: 0px 16px;
      box-shadow: none;
      // color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      // border-right: 1px solid #000;
    }

    .light {
      background: rgb(43, 56, 66);
    }

    .data {
      display: inline-block;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .dark {
      background: rgb(34, 45, 53);
    }

    .todetail {
      padding: 6px 10px;
      border: 1px solid #55B491;
      border-radius: 6px;
      background-color: @primaryButtonColor;
      color: #fff;
      font-size: 14px;
      z-index: 1;
      margin-right: 10px;
      // position: absolute;
      cursor: pointer;
    }
  }
  .upgardeButtomUP{
    height: 100px;
  }
  .upgardeButtomDo{
    height: 60px;
  }
  .upgardeButtom {
    // width: 100%;
    // display: flex;
    position: relative;
    // height: 60px;
    background-color: #2b3842;
    // align-items: center;
    text-align: center;

    .progressBox {
      // position: absolute;
      // top: 20px;
      // z-index: 99;
      position: absolute;
      top: 60%;
      z-index: 99;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;

      /deep/.el-progress__text {
        color: #ffffff;
      }
      .firDesc{
        // position: absolute;
        // bottom: 10px;
        // z-index: 99;
        margin-left: 10px;
        color: #fff;
        .item {
          max-width: 480px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: block;
          text-align: left;
        }
      }
    }
    .buttonBoxUP{
      padding: 35px 0;
    }
    .buttonBoxDo{
      padding: 10px 0;
    }
    .buttonBox {
      // padding: 10px 0;

      .btn-dark1 {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
        padding: 8px 66px;
        border-radius: 6px;
        height: 36px;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  // .maskBox {
  //   width: 100%;
  //   background-color: rgba(34, 45, 53, 0.7);
  //   position: relative;
  //   height: 536px;
  //   left: 0px;
  //   top: -536px;
  //   z-index: 95;
  // }
    &.mask-active {
    .bTitle2,
    .table,
    .buttonBox {
      pointer-events: none;
      user-select: none;
      opacity: 0.45;
    }
  }
}
</style>